<template>
  <div class="real">
    <CommonTitle titleText="重设密码"></CommonTitle>
    <el-form :model="form" ref="form" label-width="140px" label-position="left" :rules="rules">
      <el-form-item label="账号（手机号码）:" prop="loginName">
        <el-input disabled v-model="form.loginName" placeholder="用户名"></el-input>
      </el-form-item>

      <el-form-item label="旧密码:" prop="oldPwd">
        <el-input type="password" v-model="form.oldPwd" placeholder="旧密码"></el-input>
      </el-form-item>

      <el-form-item label="新密码:" prop="newPwd">
        <el-input type="password" v-model="form.newPwd" placeholder="新密码"></el-input>
      </el-form-item>


      <el-form-item label="确认密码:" prop="newPwd2">
        <el-input type="password" v-model="form.newPwd2" placeholder="新密码"></el-input>
      </el-form-item>
    </el-form>

    <div class="flex flex_align-items flex_justify-center button">
      <el-button @click="handleSaverUser('form')" style="width: 30%" type="primary" :loading="loading">修改密码</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "userRealName",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if(value.length < 6) {
        callback(new Error('密码长度大于6位数'));
      } else {
        callback();
      }
    };

    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPwd2) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      form: {
        loginName	: '',
        oldPwd: '',
        newPwd: '',
        newPwd2: '',
      },
      rules: {
        loginName	: [
          { required: true, message: '请输入账号', trigger: ['blur'] },
        ],
        oldPwd: [
          { required: true, validator: validatePass, trigger: ['blur'] },
        ],
        newPwd: [
          { required: true, validator: validatePass, trigger: ['blur'] },
          { min: 6,  message: '请输入6个字符以上密码', trigger: 'blur' }
        ],
        newPwd2: [
          { required: true, validator: validatePass2, trigger: ['blur'] },
        ],
      },
      loading: false
    }
  },
  created() {
    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.form.loginName = res.data.loginName
      }
    })

  },
  methods: {
    handleSaverUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$post(this.$API.MEMBER_UPDATEPWD,{
            ...this.form
          }).then(res => {
            if(res.code === 200) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                for(let i in this.form) {
                  if(i !== 'loginName') {
                    this.form[i] = ''
                  }
                }
              }, 1000)
            } else {
              this.$message.error(res.msg)
            }

            setTimeout(() => {
              this.saverLoading = false
            }, 1000)
            this.loading = false
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.real {

}
</style>
